var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.imageSrc)?_c('div',{staticClass:"resource-image-container",on:{"click":_vm.triggerClick,"keydown":_vm.triggerClick}},[_c('img',{class:[
        {
          thumbnail: _vm.isThumbnail,
          'preview-thumbnail': _vm.previewThumbnail,
          'big-picture': _vm.bigPicture,
          small: _vm.small,
        },
      ],attrs:{"src":_vm.imageSrc,"alt":_vm.alt}}),(_vm.previewThumbnail)?_c('div',{class:['middle', { 'mx-auto': _vm.centered }]},[_c('v-icon',{attrs:{"x-large":"","color":"blue"}},[_vm._v("mdi-magnify-plus-outline")])],1):_vm._e()]):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }